module.exports = __webpack_public_path__ + "static/media/SB.ecf2710f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/SB.svg
// module id = 352
// module chunks = 0